import React from 'react'
import { ImageForbidden, ImageForbiddenWrapper } from './styles'

export const Forbidden = () => {
  return (
    <ImageForbiddenWrapper>
      <ImageForbidden src={process.env.PUBLIC_URL + '/Forbidden.png'} alt='Forbidden' />
    </ImageForbiddenWrapper>
  )
}
